import { useMutation } from '@tanstack/react-query';
import {
  CreateMerchantCredentialDto,
  MerchantApiCredentialsService,
} from 'services/openapi';

export const useCreateMerchantCredentialMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, CreateMerchantCredentialDto>({
      mutationFn: (variables: CreateMerchantCredentialDto) =>
        MerchantApiCredentialsService.merchantApiControllerCreateClient(
          variables,
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
